import { keepPreviousData, useQuery } from '@tanstack/react-query';
import API, { generalApiUrl as GeneralQK } from './api';
import { ResponseType } from 'src/constants/data';
import { Tabs } from '../selected-materials/selected-materials';

export const useGetServices = (data: { type: Tabs }) => {
  return useQuery({
    queryKey: [GeneralQK + '/services', ResponseType.List, data],
    queryFn: () => API.getServices(data),
    placeholderData: keepPreviousData
  });
};

export const useGetContacts = (data: { type: Tabs }) => {
  return useQuery({
    queryKey: [GeneralQK + '/contacts', ResponseType.List, data],
    queryFn: () => API.getContacts(data),
    placeholderData: keepPreviousData
  });
};

export const useGetMaterials = (data: { type: Tabs }) => {
  return useQuery({
    queryKey: [GeneralQK + '/materials', ResponseType.List, data],
    queryFn: () => API.getMaterials(data),
    placeholderData: keepPreviousData
  });
};

export const useGetNews = () => {
  return useQuery({
    queryKey: [GeneralQK + '/news', ResponseType.List],
    queryFn: () => API.getNews(),
    placeholderData: keepPreviousData
  });
};

export const useGetVacancies = () => {
  return useQuery({
    queryKey: [GeneralQK + '/vacancies', ResponseType.List],
    queryFn: () => API.getVacancies(),
    placeholderData: keepPreviousData
  });
};

export const useGetEvents = () => {
  return useQuery({
    queryKey: [GeneralQK + '/events', ResponseType.List],
    queryFn: () => API.getEvents(),
    placeholderData: keepPreviousData
  });
};
